import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Typography } from '@material-ui/core';
import { formatPhone } from 'helpers/formatters';

import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

import { loadFilters } from 'components/Filter/store/thunk';
import { loadRestrictions } from 'pages/EmployeesRegistration/store/thunk';

export default function UserUpdate({ activityData, lastRegister, newRegister }) {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { selects } = useSelector(state => state.filters);
  const { restrictionsApp } = useSelector(state => state.employeesRegistration);

  const profiles = selects
    ?.find(filter => filter?.id == 'profile')
    ?.options;

  useEffect(() => {
    dispatch(loadFilters(userId, establishmentId));
    dispatch(loadRestrictions(userId));
  }, []);

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader activityData={activityData} />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Informações Anteriores</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(lastRegister).includes('name') && (
                <Row>
                  <Typography color='primary'>
                    <b>Nome</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.name || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('email') && (
                <Row>
                  <Typography color='primary'>
                    <b>Email</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.email || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('phone') && (
                <Row>
                  <Typography color='primary'>
                    <b>Telefone</b>
                  </Typography>
                  <Typography color='textSecondary'>{formatPhone(lastRegister?.phone) || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('profileId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Perfil</b>
                  </Typography>
                  <Typography color='textSecondary'>{profiles?.find(profile => +profile.value == +lastRegister?.profileId)?.name}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('availableEstablishments') && (
                <Row>
                  <Typography color='primary'>
                    <b>Estabelecimentos</b>
                  </Typography>
                  <Typography color='textSecondary'>
                    {lastRegister?.availableEstablishments?.map(establishment => establishment?.establishmentName)?.join(', ')}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('appRestrictions') && (
                <Row>
                  <Typography color='primary'>
                    <b>Restrições</b>
                  </Typography>
                  <Typography color='textSecondary'>
                    {restrictionsApp?.filter(restriction => lastRegister?.appRestrictions?.includes(restriction?.id))?.map(restriction => restriction?.description)?.join(', ') || '--'}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5, marginBottom: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Informações Atuais</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(newRegister).includes('name') && (
                <Row>
                  <Typography color='primary'>
                    <b>Nome</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.name || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('email') && (
                <Row>
                  <Typography color='primary'>
                    <b>Email</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.email || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('phone') && (
                <Row>
                  <Typography color='primary'>
                    <b>Telefone</b>
                  </Typography>
                  <Typography color='textSecondary'>{formatPhone(newRegister?.phone) || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('profileId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Perfil</b>
                  </Typography>
                  <Typography color='textSecondary'>{profiles?.find(profile => +profile.value == +newRegister?.profileId)?.name}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('availableEstablishments') && (
                <Row>
                  <Typography color='primary'>
                    <b>Estabelecimentos</b>
                  </Typography>
                  <Typography color='textSecondary'>
                    {newRegister?.availableEstablishments?.map(establishment => establishment?.establishmentName)?.join(', ')}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('appRestrictions') && (
                <Row>
                  <Typography color='primary'>
                    <b>Restrições</b>
                  </Typography>
                  <Typography color='textSecondary'>
                    {restrictionsApp?.filter(restriction => newRegister?.appRestrictions?.includes(restriction?.id))?.map(restriction => restriction?.description)?.join(', ') || '--'}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}